import { Checkbox } from "@/shared/components/ui/checkbox";
import { Position } from "@/services/backend/rlt/treatments/types/position";
import { useMemo } from "react";
import { useRltTreatmentUpdateCycleDiscountActiveAllMutation } from "@/services/backend/rlt/treatments/api/treatment-api";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";

export function CycleDiscountAllCheckbox({
  treatmentId,
  positions,
  disabled = false,
}: {
  treatmentId: string;
  positions: Position[];
  disabled?: boolean;
}) {
  const [update, { isLoading }] =
    useRltTreatmentUpdateCycleDiscountActiveAllMutation();

  const checked = useMemo(() => {
    const allActive = positions.every((p) => p.cycleDiscountActive);
    const indeterminate =
      positions.some((p) => p.cycleDiscountActive) && !allActive;
    if (allActive) {
      return true;
    }
    return indeterminate ? "indeterminate" : false;
  }, [positions]);

  return (
    <div className="hover:bg-accent hover:text-accent-foreground bg-background flex h-9 items-center gap-2 rounded-md border px-4 py-2 shadow-xs">
      <Checkbox
        id={`cycle-discount-all-checkbox-${treatmentId}`}
        checked={checked}
        onCheckedChange={(value) => {
          switch (value) {
            case "indeterminate":
            case true:
              update({
                id: treatmentId,
                active: true,
              });
              break;
            case false:
              update({
                id: treatmentId,
                active: false,
              });
              break;
            default:
          }
        }}
        disabled={isLoading || disabled}
      />
      <Label
        htmlFor={`cycle-discount-all-checkbox-${treatmentId}`}
        className="cursor-pointer"
      >
        {t("Turnusrabatt alle")}
      </Label>
    </div>
  );
}
